import React, { useEffect } from "react";
import "antd/dist/antd.css";
import styles from "./Home.module.css";
import { Typography } from "antd";
import { UserContext } from "../Reducers/UserContext";
import { GuestSection } from "./Guest";
import { AdminSection } from "./Admin";
import { ResearchersSection } from "./Researcher";
import { ResearchAdminSection } from "./ResearchAdmin";
import { fetchUserVal } from "../../api";
const { Title } = Typography;

const Home = ({
  setActiveState,
  setOpenKeys,
  setMenu,
  isLoggedIn,
  setLogger,
  hom,
}) => {
  const fetchUserRole = async () => {
    const { data } = await fetchUserVal("checkUser", {
      firstVal: "dummy",
      secondVal: isLoggedIn["user"]["imageUrl"],
      thirdVal: isLoggedIn["user"]["name"],
      fourthVal: isLoggedIn["user"]["email"],
    });
    if (
      data[0][0]["role"].toLowerCase().trim() !=
      isLoggedIn["user"]["role"].toLowerCase().trim()
    ) {
      setLogger({
        active: isLoggedIn["active"],
        user: {
          name: isLoggedIn["user"]["name"],
          imgUrl: isLoggedIn["user"]["imgUrl"],
          role: data[0][0]["role"],
          email: isLoggedIn["user"]["email"],
        },
      });
      console.log(data[0][0]["role"], isLoggedIn["user"]["imgUrl"]);
    }
  };

  useEffect(() => {
    console.log("state");
    fetchUserRole();
  }, [hom]);

  if (
    isLoggedIn["user"]["role"].toLowerCase().trim() === "guest" ||
    isLoggedIn["user"]["role"].toLowerCase().trim().includes("report")
  ) {
    return (
      <GuestSection
        setActiveState={setActiveState}
        setOpenKeys={setOpenKeys}
        setMenu={setMenu}
        role={isLoggedIn["user"]["role"].toLowerCase().trim()}
      />
    );
  } else if (isLoggedIn["user"]["role"].toLowerCase().trim() === "admin") {
    return (
      <AdminSection role={isLoggedIn["user"]["role"].toLowerCase().trim()} />
    );
  } else if (['researcher'].includes(isLoggedIn["user"]["role"].toLowerCase().trim())) {
    return (
      <ResearchersSection
        role={isLoggedIn["user"]["role"].toLowerCase().trim()}
        email={isLoggedIn["user"]["email"]}
      />
    );
  } else if (['research admin', 'reviewer'].includes(isLoggedIn['user']['role'].toLowerCase().trim())) {
      return <ResearchAdminSection role={isLoggedIn['user']['role'].toLowerCase().trim()} email={isLoggedIn['user']['email']} />;
  } else {
      return (
          <div className={styles.pageHome}>
              <Title level={3}> Undefined user role -: {isLoggedIn['user']['role'].toLowerCase()}</Title>
          </div>
      );
  }
};

export default Home;
